import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import Title, { ITitle } from './title/Title'

const Container = ({
  title,
  children,
  className,
  footer,
  dataGtm,
}: {
  title?: ITitle
  children: React.ReactElement
  className?: string
  footer?: React.ReactElement
  dataGtm?: string
}) => {
  return (
    <div className={clsx(s.container, className)}>
      {title && (
        <Title
          {...title}
          dataGtm={dataGtm}
          style={{
            paddingRight: '20px',
            paddingTop: title.label == '' ? '0' : undefined,
            marginBottom: title.label == '' ? '0' : undefined,
          }}
        />
      )}
      {children}
      {!!footer && footer}
    </div>
  )
}

export default Container
